import webContextProvider from "../../../../providers/webContextProvider";
import clientConfigurationProvider from "../../../../providers/clientConfigurationProvider";

const isLastBestPriceEnabled = () => {
  const { lastBestPriceEnabledCountries } = clientConfigurationProvider();
  const { browseCountry } = webContextProvider();

  return lastBestPriceEnabledCountries.includes(browseCountry);
};

export default isLastBestPriceEnabled;
